/**
 * Canonical form used to match and de-duplicate county names. There is no county reference list (atm),
 * so admin entered names and resolved names must meet in a "common" spelling
 */
export const normalizeCountyName = (name: string): string =>
  name
    .toLowerCase()
    .replace(/\./g, '')
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/(^| )county$/, '')
    .replace(/^saint /, 'st ');
